import { createContext, useContext } from 'react';
import type { MfaChallenge, Session } from '../types';

export interface AuthContextValue {
  loading: boolean;
  session?: Session;
  login: (email: string, password: string) => Promise<MfaChallenge | undefined>;
  verifyMfa: (challengeId: string, code: string) => Promise<void>;
  updateProfile: (displayName: string) => Promise<void>;
  changePassword: (currentPassword: string, newPassword: string) => Promise<void>;
  refreshSession: () => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue | undefined>(undefined);

export function useAuth(): AuthContextValue {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used inside AuthProvider');
  return context;
}
